module.exports = __webpack_public_path__ + "static/media/two-days-active.a0fd0928.png";